import { queryOptions } from '@tanstack/react-query'
import axios from '@/shared/api/axios'
import { AUTH_BASE_KEY, AUTH_PATH } from '../const'
import type {
  GetMeResponse,
  LoginDto,
  LoginResponse,
  RefreshTokenDto,
  RefreshTokenResponse,
  RequestPasswordResetDto,
  SetNewPasswordDto,
} from '../types'

export const authService = {
  login: async (dto: LoginDto) => {
    const { data } = await axios.post<LoginResponse>(`${AUTH_PATH}/login`, dto)

    return data
  },

  logout: async ({ refreshToken }: { refreshToken: string }) => {
    const { data } = await axios.post(`${AUTH_PATH}/logout`, { refreshToken })

    return data
  },

  getMe: queryOptions({
    queryKey: [AUTH_BASE_KEY, 'me'],
    queryFn: async () => {
      const { data } = await axios.get<GetMeResponse>(`${AUTH_PATH}/me`)
      return data
    },
    staleTime: 60 * 5,
    gcTime: 60 * 5,
  }),

  refreshToken: async (dto: RefreshTokenDto) => {
    const { data } = await axios.post<RefreshTokenResponse>(`${AUTH_PATH}/refresh-token`, dto)
    return data
  },

  requestPasswordReset: async (dto: RequestPasswordResetDto) => {
    const { data } = await axios.post(`${AUTH_PATH}/request-password-reset`, dto)
    return data
  },

  setNewPassword: async (dto: SetNewPasswordDto) => {
    const { data } = await axios.post(`${AUTH_PATH}/set-new-password`, dto)
    return data
  },

  verifyOtp: ({ otp, enabled = false }: { otp: number; enabled?: boolean }) =>
    queryOptions({
      queryKey: [AUTH_BASE_KEY, 'verify-otp'],
      queryFn: async () => {
        const { data } = await axios.get(`${AUTH_PATH}/verify-otp?otp=${otp}`)
        return data
      },
      enabled,
    }),
}
